import Layout from 'common/Layout';
import { Navigate, Outlet } from 'react-router-dom';
import useAutoLogout from '../hooks/useAutoLogout';

const PrivateRouter = () => {
  const token = localStorage.getItem('token') || localStorage.getItem('userToken') || sessionStorage.getItem('userToken');
  const userStr = localStorage.getItem('user');

  let isAdmin = false;
  if (token && userStr) {
    try {
      const userObj = JSON.parse(userStr);
      if (userObj && userObj.role === 'admin') {
        isAdmin = true;
      }
    } catch (e) {
      console.error('Invalid user JSON in localStorage:', e);
    }
  }

  // Auto-logout after 1 hour of inactivity
  useAutoLogout(isAdmin);

  if (!isAdmin && (token || userStr)) {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('userToken');
    sessionStorage.removeItem('userToken');
  }

  return (
    <div>
      {isAdmin ? (
        <Layout>
          <Outlet />
        </Layout>
      ) : (
        <Navigate to={'/signin'} replace/>
      )}
    </div>
  );
};
export default PrivateRouter;
